import { NgModule } from '@angular/core';
import { ExtractDomainPipe } from '@shared/pipes/extract-domain.pipe';
import { SafeTimeagoPipe } from '@shared/pipes/safe-timeago.pipe';
import { DatePipe } from './date.pipe';
import { FileSizePipe } from './file-size.pipe';
import { FilterConnectorsPipe, FilterOptionsPipe } from './filter.pipe';
import { HexColorPipe } from './hexColor.pipe';
import { MentionPipe } from './mention.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { SafeTruncatePipe } from './safe-truncate.pipe';
import { StripHtmlPipe } from './strip-html.pipe';
import { TruncateUrlPipe } from './truncate-url.pipe';
import { UserInitialsPipe } from './user-initials.pipe';

import { SanitizeHtmlPipe } from './sanitize-html.pipe';

@NgModule({
  declarations: [
    FileSizePipe,
    FilterConnectorsPipe,
    FilterOptionsPipe,
    SafeHtmlPipe,
    SafeTruncatePipe,
    StripHtmlPipe,
    TruncateUrlPipe,
    DatePipe,
    HexColorPipe,
    UserInitialsPipe,
    MentionPipe,
    SafeTimeagoPipe,
    SanitizeHtmlPipe,
  ],
  imports: [ExtractDomainPipe],
  exports: [
    FileSizePipe,
    FilterConnectorsPipe,
    FilterOptionsPipe,
    SafeHtmlPipe,
    SafeTruncatePipe,
    StripHtmlPipe,
    TruncateUrlPipe,
    DatePipe,
    HexColorPipe,
    SanitizeHtmlPipe,
    UserInitialsPipe,
    MentionPipe,
    SafeTimeagoPipe,
    ExtractDomainPipe,
  ],
})
export class PipesModule {}
